import React from 'react';
import Helmet from 'react-helmet';

const MetaInfo = (props) => {

    return (
        <>
            {props.lang !== 'fr' ?
                <Helmet>
                    <title>Animal Welfare</title>
                    <meta name="description" content="Whether it’s high-quality meat like our beef, chicken and pork or fresh produce like our tomatoes, onions and cheese, good food is at the heart of what we do." />
                </Helmet>
            :
                <Helmet>
                    <title>Bien-être animal</title>
                    <meta name="description" content="A&W s’engage à travailler de concert avec les producteurs et les experts du bien-être animal pour veiller à ce que les animaux de notre chaîne d’approvisionnement soient traités de façon humaine." />
                </Helmet>
            }
        </>
    )
}
export default MetaInfo;